var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"webhooks",attrs:{"title":"Webhooks","icon":"swatchbook"}},[_c('InstallationWebhookList',{ref:"list",attrs:{"installation-id":_vm.installationId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }